"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SummaryTable_1 = __importDefault(require("@Components/RoyaltiesTable/SummaryTable"));
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/plugin/isSameOrAfter");
const CUTOFF_DATE = (0, dayjs_1.default)('2022-06-01');
const CUTOFF_DATE_FOR_PHONO_ADJUSTMENTS = (0, dayjs_1.default)('2024-09-01');
const RoyaltiesUsagePeriod = (props) => {
    const { statementsStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { usagePeriod, setSelectedData, setSidebarIsOpen, pdfString } = props;
    const usagePeriodDay = usagePeriod ? (0, dayjs_1.default)(usagePeriod === null || usagePeriod === void 0 ? void 0 : usagePeriod.value, 'MM-YYYY') : null;
    const distributionSummaryPdfLink = statementsStore.distributionSummaryPdfLink;
    return (react_1.default.createElement(react_1.default.Fragment, null, (usagePeriod === null || usagePeriod === void 0 ? void 0 : usagePeriod.value) && (react_1.default.createElement(react_1.default.Fragment, null,
        distributionSummaryPdfLink && (react_1.default.createElement("div", { className: "distribution-summary-pdf-link" },
            react_1.default.createElement("a", { href: distributionSummaryPdfLink, target: '_blank', rel: "noreferrer" },
                react_1.default.createElement("img", { src: common_1.ICONS.pdfIcon, alt: "distribution-summary-pdf" }),
                "Distribution Summary"))),
        statementsStore.royalties && (react_1.default.createElement(SummaryTable_1.default, { data: statementsStore.royalties, period: usagePeriod, openStatusSidebar: (data) => {
                setSelectedData(data);
                setSidebarIsOpen(true);
            } })),
        react_1.default.createElement("div", { className: "distribution-notes-link" },
            react_1.default.createElement("a", { href: `https://resources.themlc.com/distribution/release-notes-${pdfString}`, target: '_blank', rel: "noreferrer" },
                react_1.default.createElement("img", { src: common_1.ICONS.pdfIcon, alt: "pdf" }),
                "Distribution Notes for Blanket Licensing Activities")),
        usagePeriodDay && usagePeriodDay.isSameOrAfter(CUTOFF_DATE_FOR_PHONO_ADJUSTMENTS, 'month') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "distribution-notes-link" },
                react_1.default.createElement("a", { href: `https://resources.themlc.com/distribution/release-notes-p3-adjustments-${pdfString}`, target: '_blank', rel: "noreferrer" },
                    react_1.default.createElement("img", { src: common_1.ICONS.pdfIcon, alt: "pdf" }),
                    "Distribution Notes for Phono III Adjustments")),
            react_1.default.createElement("div", { className: "distribution-notes-link" },
                react_1.default.createElement("a", { href: `https://resources.themlc.com/distribution/release-notes-p4-adjustments-${pdfString}`, target: '_blank', rel: "noreferrer" },
                    react_1.default.createElement("img", { src: common_1.ICONS.pdfIcon, alt: "pdf" }),
                    "Distribution Notes for Phono IV Adjustments")))),
        usagePeriodDay && usagePeriodDay.isSameOrAfter(CUTOFF_DATE, 'month') && (react_1.default.createElement("div", { className: "distribution-notes-link" },
            react_1.default.createElement("a", { href: `https://resources.themlc.com/distribution/release-notes-historical-${pdfString}`, target: '_blank', rel: "noreferrer" },
                react_1.default.createElement("img", { src: common_1.ICONS.pdfIcon, alt: "pdf" }),
                "Distribution Notes for Historic Activities"))),
        react_1.default.createElement("div", { className: "distribution-notes-link" },
            react_1.default.createElement("a", { href: `https://resources.themlc.com/distribution/distribution-certification-${pdfString}`, target: '_blank', rel: "noreferrer" },
                react_1.default.createElement("img", { src: common_1.ICONS.pdfIcon, alt: "pdf" }),
                "View Distribution Certification"))))));
};
exports.default = (0, mobx_react_1.observer)(RoyaltiesUsagePeriod);
